/**
 * Created by mark on 11/12/2017.
 */



import React  from 'react';
import {Row , Col ,  Form , Button , Card} from 'react-bootstrap'
import AuthenticationService from '../../services/authenticate-service.js';

export default class Authentication extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            username:"school",
            password:"school",
            secret:''
        };
    }


    authentication(){
        AuthenticationService.authenticate(this.state.username , this.state.password).then(function(response){
            console.log(response)
        });
    }


    render(){


        return  <Card body className="my-5">
            <Row>
                <Col xs={6}>
                    <Card bg="light" body>
                        <p className="lead">Login</p>
                        <Form>
                            <Form.Group controlId="formBasicEmail">
                            <Form.Label>Username</Form.Label>
                            <Form.Control type="text" placeholder="Enter username"
                                          value={this.state.username}
                                          onChange={(e)=>{ this.setState({username:e.target.value})}}

                                />
                            </Form.Group>
                            <Form.Group controlId="formBasicPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" placeholder="Password"   value={this.state.password}
                                          onChange={(e)=>{ this.setState({password:e.target.value})}}/>
                            </Form.Group>
                            <Button onClick={this.authentication.bind(this)} variant="primary" >
                                Submit
                            </Button>
                        </Form>
                    </Card>
                </Col>
                <Col xs={6}>
                    <Card border="light" body>
                    <p className="lead">Register now for <span className="text-success">FREE</span></p>
                    <ul className="list-unstyled" style={{"lineHeight":"2"}}>
                        <li><span class="fa fa-check text-success"></span> See all your orders</li>
                        <li><span class="fa fa-check text-success"></span> Fast re-order</li>
                        <li><span class="fa fa-check text-success"></span> Save your favorites</li>
                        <li><span class="fa fa-check text-success"></span> Fast checkout</li>
                        <li><span class="fa fa-check text-success"></span> Get a gift <small>(only new customers)</small></li>
                        <li><a href="/read-more/"><u>Read more</u></a></li>
                    </ul>
                    <p><a href="/new-customer/" class="btn btn-info btn-block">Yes please, register now!</a></p>
                    </Card>
                </Col>
            </Row>
        </Card>;

    }

}